module.exports = __webpack_public_path__ + "static/media/8784.01cf2678.png";